import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import classes from './AdministracionNotificacionesInternas.module.css';
import { Grid, Typography, TextField } from "@mui/material";
import { loadClientes } from "../../store/slices/clientesSlice";
import NotificacionInterna from "../../components/UI/NotificacionInterna/NotificacionInterna";

const AdministracionNotificacionesInternas = () => {
  const dispatch = useDispatch();
  sessionStorage.setItem('seccionNombre', 'Administración de Notificaciones Internas');
  const { loading, items, estaCargado } = useSelector(state => state.clientes.clientes);
  const [idCliente, setIdCliente] = useState('0');
  const [idEmpresa, setIdEmpresa] = useState('0');
  const [empresas, setEmpresas] = useState([]);

  useEffect(() => {
    if (!loading && !estaCargado) {
      dispatch(loadClientes());
    }
  }, [loading, estaCargado, dispatch]);

  const onClienteChange = (value) => {
    setIdCliente(value);
    setIdEmpresa('0');
    setEmpresas([]);
    
    const cliente = items.find((item) => item.id === Number(value));

    if (cliente) {
      setEmpresas(cliente.empresas);
    }
  }

  const onEmpresaChange = (value) => {
    setIdEmpresa(value);
  }

  const getUsuarios = () => {
    let usuarios = [];

    if (idCliente === '0') {
      items.forEach((item) => {
        usuarios = usuarios.concat(item.idUsuarios);
      });
    } else {
      const cliente = items.find((item) => item.id === Number(idCliente));

      if (cliente) {
        usuarios = cliente.idUsuarios;

        if (idEmpresa !== '0' && cliente.empresas) {
          const empresa = cliente.empresas.find((item) => item.id === Number(idEmpresa));

          if (empresa) {
            usuarios = empresa.idUsuarios;
          }
        }
      }
    }

    return usuarios;
  }

  return (
    <Grid container spacing={1} className={classes.PanelContainer} >
      <Grid item xs={12} lg={6}>
        <Typography variant="h5">
          Administración de Notificaciones Internas
        </Typography>
      </Grid>
      <Grid item xs={12} lg={6} container spacing={1}>
        <Grid item xs={12} md={6} xl={4}>
          <TextField
            select
            label="Seleccionar Cliente"
            placeholder=""
            value={idCliente}
            onChange={(e) => onClienteChange(e.target.value)}
            SelectProps={{
              native: true,
            }}
            variant="standard"
            fullWidth={true}
          >
            <option value="" disabled></option>
            <option value="0">Todos los clientes</option>
            {items.map((cliente) => (
              <option key={cliente.id} value={cliente.id}>
                {cliente.nombre}
              </option>
            ))}
          </TextField>
        </Grid>
        <Grid item xs={12} md={6} xl={4}>
          <TextField
            select
            label="Seleccionar Empresa"
            value={idEmpresa}
            onChange={(e) => onEmpresaChange(e.target.value)}
            SelectProps={{
              native: true,
            }}
            variant="standard"
            fullWidth={true}
          >
            <option value="" disabled></option>
            <option value="0">Todas las empresas</option>
            {empresas.map((empresa) => (
              <option key={empresa.id} value={empresa.id}>
                {empresa.nombre}
              </option>
            ))}
          </TextField>
        </Grid>
      </Grid>
      <Grid item xs={12} lg={6}>
        <Typography variant="h6">
          Notificación interna
        </Typography>
        <NotificacionInterna
          idUsuarios={getUsuarios()}
        />
      </Grid>
    </Grid>
  )
}

export default AdministracionNotificacionesInternas;